import { Component, ComponentFactoryResolver, Input, OnInit, Type, ViewChild, ViewContainerRef } from '@angular/core';
import { MissingValueService } from '@app/services/missing-value/missing-value.service';
import { WorkflowItemDataDirective } from '@app/workflow/directives/workflow-item-data/workflow-item-data.directive';
import { BehaviorSubject, combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { IQuestionnaireOverviewItem } from '@interfaces/interfaces';

@Component({
	selector: 'workflow-special-question-epilog',
	templateUrl: './special-question-epilog.component.html',
})
export class SpecialQuestionEpilogComponent implements OnInit {

	@Input() component: Type<SpecialQuestionEpilogComponent>;
	@Input() overviewConfigs: IQuestionnaireOverviewItem[];
	@Input() finishedAndLocked: boolean;

	@Input()
	set missingValueKey(value: string) {
		this.missingValueKey$.next(value);
	}
	private missingValueKey$ = new BehaviorSubject<string>(undefined);

	@ViewChild('container', {read: ViewContainerRef, static: true}) container: ViewContainerRef;

	hasMissingValue$: Observable<boolean>;

	constructor(
		private componentFactoryResolver: ComponentFactoryResolver,
		private workflowItemData: WorkflowItemDataDirective,
	) {}

	ngOnInit(): void {
		this.hasMissingValue$ = combineLatest([this.workflowItemData.data$, this.missingValueKey$]).pipe(
			map(([data, missingValueKey]) => !!MissingValueService.isMissingValue({missingValueKey}, data)),
		);
		this.loadComponent(this.container);
	}

	private loadComponent(viewContainerRef: ViewContainerRef) {
		viewContainerRef.clear();
		return viewContainerRef.createComponent(this.componentFactoryResolver.resolveComponentFactory(this.component));
	}
}
